import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export const formatUtc = (iso) => dayjs.utc(iso).format("DD MMM HH:mm")
